import styles_field from "../Field/Field.module.css";
import React from "react";

export function SelectFilter({ label = "", selectId = "selectFilter", onChangeSelect = null, options = [{value: 0, label: "Défaut"}], defaultValue = null }) {

  const optionsElements = options.map((option, index) => {
      return <option key={index} value={option.value}>{option.label}</option>;
    });

    return (
      <div>
          <label htmlFor={selectId} style={{marginRight: "4px"}}>{ label }</label>
          <div style={{
              display: "flex",
              flexDirection: "row",
              gap: "8px",
              padding: "8px",
              outline: "1px solid var(--clr-accent)",
          }}>
              <select id={selectId} onChange={onChangeSelect} className={styles_field.inputy} value={defaultValue || ""}>
                    {optionsElements}
              </select>
          </div>
      </div>
  );
}